import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/deals/:hubspotDealId/eligible-collaborators
//
// Backs the add-collaborator dialog inside the drawer. Returns the
// `vendors` (internal staff) + `partnerUsers` (users belonging to the
// deal's attributed partners) as separate arrays. The dialog filters out
// the already-added rows + the HubSpot owner.
//
// Only fetched when the dialog is actually open — the drawer wraps this
// hook with `enabled` derived from the open state to keep idle drawer
// mounts from firing.

export type EligibleCollaboratorOption = {
  id: string;
  name: string | null;
  email: string | null;
};

export type EligibleCollaborators = {
  vendors: EligibleCollaboratorOption[];
  partnerUsers: EligibleCollaboratorOption[];
};

export function useEligibleCollaborators(
  hubspotDealId: string | null | undefined,
  enabled: boolean,
) {
  return useQuery<EligibleCollaborators, ApiClientError>({
    queryKey: queryKeys.admin.deals.eligibleCollaborators(hubspotDealId ?? ""),
    queryFn: () =>
      apiFetch<EligibleCollaborators>(
        `/admin/deals/${hubspotDealId}/eligible-collaborators`,
      ),
    enabled: !!hubspotDealId && enabled,
  });
}
